import React from 'react';
import { MapPin, PhoneCall, Mail } from 'lucide-react';
import './Contact.css';

const Contact = () => (
  <div className="page-container fade-in">
    <header className="contact-header">
      <h1>Contact Us</h1>
      <p>Home • <span className="teal-text">Get In Touch</span></p>
    </header>

    <div className="contact-content">
      {/* New Title Section to match reference */}
      <div className="contact-details-title">
        <span className="teal-subtitle">FOCUSED WITH WORK</span>
        <h2>Contact Details</h2>
      </div>
      
      <div className="info-grid">
        <ContactCard 
          icon={<MapPin size={32} />} 
          title="acurio.io Office" 
          detail="123 Dental Tech Way, San Francisco, CA" 
          bgClass="teal-bg"
        />
        <ContactCard 
          icon={<PhoneCall size={32} />} 
          title="Client Support" 
          detail="24/7 Line: +1 (800) 123-4567" 
          bgClass="blue-bg"
        />
        <ContactCard 
          icon={<Mail size={32} />} 
          title="General Inquiries" 
          detail="hello@acurio.io" 
          bgClass="purple-bg"
        />
      </div>

      <div className="form-wrapper">
        <div className="form-side">
          <h2>Get Free Quote</h2>
          <p className="form-subtitle">acurio.io — Leave us a message.</p>
          <form>
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Email address" />
            <input type="text" placeholder="Phone No" />
            <textarea placeholder="Message"></textarea>
            <button type="submit">SEND NOW</button>
          </form>
        </div>
        
        <div className="form-image-side">
          <div className="image-container">
            <img 
              src="/contactus.jpg" 
              alt="Team Meeting" 
            />
          </div>
          <div className="image-info-pane">
             <div className="pane-row">
                <PhoneCall size={20} />
                <span>+1 (800) 123-4567</span>
             </div>
             <div className="pane-row">
                <Mail size={20} />
                <span>hello@acurio.io</span>
             </div>
             <small>Verified • Credentialed • Paid Seamlessly</small>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ContactCard = ({ icon, title, detail, bgClass }) => (
  <div className="info-card">
    <div className={`icon-bg ${bgClass}`}>{icon}</div>
    <h3>{title}</h3>
    <p>{detail}</p>
  </div>
);

export default Contact;